import {Inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {Observable, of as observableOf} from 'rxjs';
import {catchError, map, switchMap, tap} from 'rxjs/operators';

import * as roleActions from './roles.actions';
import {DOCUMENT} from '@angular/common';
import {LocalStorageService} from '../../../../../core/services';
import {AUTH_ACCESS_TOKEN, NotificationService} from '../../../../../core';
import {RolService} from 'src/app/core/services';

@Injectable()
export class RolesEffects {
  RoleLoadRequestEffect$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<roleActions.RolesLoadRequestAction>(
      roleActions.RolesActionTypes.LOAD_REQUEST
    ),
    switchMap(action => {
      const token = this.localStorageService.getItem(AUTH_ACCESS_TOKEN);
      return this.rolService.getRoles(token).pipe(
        map(response => {
          if (response) {
            if (response.roles) {
              return new roleActions.RolesLoadSuccessAction({
                items: response.roles
              });
            }
            return new roleActions.RolesLoadFailureAction({
              error: 'Si es Productor o Propietario debe dar de alta Empresa'
            });
          }
          return new roleActions.RolesLoadFailureAction({
            error: 'Ocurrio un error: No hay roles'
          });
        }),
        catchError(error =>
          observableOf(
            new roleActions.RolesLoadFailureAction({
              error
            })
          )
        )
      );
    })
  ));

  // Copy Dibujo
  RolesFailureEffect$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(
      roleActions.RolesActionTypes.LOAD_FAILURE,
    ),
    map(
      (
        action:
          | roleActions.RolesLoadFailureAction
      ) => action.payload.error
    ),
    tap((error: string) => this.notificationService.error(error))
  ), {dispatch: false});

  constructor(
    private rolService: RolService,
    private actions$: Actions,
    @Inject(DOCUMENT) readonly document: Document,
    private notificationService: NotificationService,
    private localStorageService: LocalStorageService
  ) {
  }
}
